/**
 * User preferences — theme + locale, persisted. The inline script in
 * index.html reads the same storage key before first paint (no flash).
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import i18n, { applyDocumentLocale, type Locale } from '../i18n';

type Theme = 'dark' | 'light';

interface PrefsState {
  theme: Theme;
  locale: Locale;
  setTheme: (t: Theme) => void;
  setLocale: (l: Locale) => void;
}

export const usePrefs = create<PrefsState>()(
  persist(
    (set) => ({
      theme: 'dark', // dark studio is the brand default
      locale: 'en',
      setTheme: (theme) => {
        document.documentElement.dataset.theme = theme;
        set({ theme });
      },
      setLocale: (locale) => {
        void i18n.changeLanguage(locale);
        applyDocumentLocale(locale);
        set({ locale });
      },
    }),
    { name: 'vidply-prefs' },
  ),
);
